import moment from 'moment';


export default {
  data() {
    return {
      ElevatorTypes: {
        "analog": { "brand": "Analog", "type": "" },
        "analogesc": { "brand": "Analog", "type": "Escalator" },
        "arca": { "brand": "Orona", "type": "Arca 2" },
        "arca3": { "brand": "Orona", "type": "Arca 3" },
        "arkel": { "brand": "Arkel", "type": "" },
        "bohnke": { "brand": "Böhnke", "type": "" },
        "cmc4": { "brand": "Thyssen", "type": "CMC4" },
        "dmg": { "brand": "DMG", "type": "" },
        "fst": { "brand": "FST", "type": "" },
        "hydro": { "brand": "Hydroware", "type": "Elite" },
        "imem": { "brand": "Imem", "type": "" },
        "kinetek": { "brand": "Kinetek", "type": "" },
        "klst": { "brand": "KLST", "type": "" },
        "kollmorgen": { "brand": "Kollmorgen", "type": "MPK411" },
        "kone": { "brand": "Kone", "type": "" },
        "konemap": { "brand": "Kone", "type": "MAP" },
        "lester": { "brand": "Lester", "type": "Almega2" },
        "lisa": { "brand": "Lisa", "type": "20" },
        "mec32": { "brand": "DAC", "type": "MEC32" },
        "mikel": { "brand": "Oleva", "type": "" },
        "mpk": { "brand": "Kollmorgen", "type": "MPK400" },
        "mpktcp": { "brand": "Kollmorgen", "type": "MPK411" },
        "mxgc": { "brand": "Schindler", "type": "MXGC" },
        "otis": { "brand": "Otis", "type": "" },
        "otisesc": { "brand": "Otis", "type": "Escalator" },
        "rst": { "brand": "RST", "type": "" },
        "schindler": { "brand": "Schindler", "type": "Smart" },
        "schindler3100": { "brand": "Schindler", "type": "3100" },
        "schindler3300": { "brand": "Schindler", "type": "3300" },
        "schindlerBX": { "brand": "Schindler", "type": "BX" },
        "schindlercan": { "brand": "Schindler", "type": "Smart (CAN)" },
        "tci": { "brand": "Thyssen", "type": "TCI" },
        "thyssen": { "brand": "Thyssen", "type": "MCI" },
        "tvc": { "brand": "TVC", "type": "Ethos 2" },
      }
    }
  },
  computed: {
    allElevatorBrands: function (elevators) {
      var eb = Object.values(this.ElevatorTypes).map(e => {
        return e.brand;
      });

      var distinct = [];
      for (var i = 0; i < eb.length; i++) {
        if (!(distinct.includes(eb[i]))) {
          distinct.push(eb[i])
        }
      }

      return distinct.sort();
    },
    allElevatorTypes: function () {
      var eb = Object.values(this.ElevatorTypes).map(e => {
        return e.type;
      });

      var distinct = [];
      for (var i = 0; i < eb.length; i++) {
        if (!(distinct.includes(eb[i]))) {
          distinct.push(eb[i])
        }
      }

      return distinct.sort();
    },
  },
  methods: {
    allElevatorTypesForBrand(brand) {
      var et = Object.values(this.ElevatorTypes).filter(e => {
        if (brand == e.brand) {
          return true;
        }
      }).
        filter(e => {
          return e.type != "";
        }).
        map(e => e.type);

      return et;
    },
    classForElevator(e) {
      switch (e.status) {
        case 9:
          return 'poweroff'
        case 8:
          return 'evac';
        case 7:
          return 'alarm';
        case 6:
          return 'fire';
        case 5:
          return 'error';
        case 4:
          return 'shutdown';
        case 3:
          return 'operational-offline-24h';
        case 2:
          return 'operational-offline-2h';
        case 1:
          return 'operational-online';
        case 0:
          return 'unknown';
        case -1:
          return 'repair';
        case -2:
          return 'maintenance-offline-24h';
        case -3:
          return 'inspection-offline-24h';
        case -4:
          return 'maintenance-offline-2h';
        case -5:
          return 'inspection-offline-2h';
        case -6:
          return 'maintenance-online';
        case -7:
          return 'inspection-online';
      }

    },
    imageForElevator(elevator) {
      if (elevator.escalator) {
        switch (elevator.status) {
          case 9:
            // Power lost
            return "/static/img/status/escalator-supply-fault.png"
          case 8:
            // 'Evac'
            //return "/static/img/status/escalator-removed.png"
            return "/static/img/status/escalator-fault.png"
          case 7:
            // 'Alarm'
            // return "/static/img/status/escalator-alarm.png"
            return "/static/img/status/escalator-fault.png"
          case 6:
            // 'Fire'
            // return "/static/img/status/escalator-fire.png"
            return "/static/img/status/escalator-fault.png"
          case 5:
            // 'Error';
            return "/static/img/status/escalator-fault.png"
          case 4:
          // 'Shutdown';
          case 3:
            // 'Offline 24h';
            return "/static/img/status/escalator-supply-fault.png"
          case 2:
            // 'Offline 2h';
            return "/static/img/status/escalator-supply-fault.png"
          case 1:
            // 'Normal'
            switch (elevator.direction) {
              case "none":
                return "/static/img/status/escalator-none.png"
              case "up":
                return "/static/img/status/escalator-up.png"
              case "down":
                return "/static/img/status/escalator-down.png"
            }
          case 0:
          // 'Unknown';
          case -1:
            // 'Ignore';
            return "/static/img/status/escalator-fault.png"
          case -2:
            // 'Maintenance';
            return "/static/img/status/escalator-fault.png"
          case -3:
            // 'Inspection';
            return "/static/img/status/escalator-fault.png"
          case -4:
            // 'Maintenance';
            return "/static/img/status/escalator-fault.png"
          case -5:
            // 'Inspection';
            return "/static/img/status/escalator-fault.png"
          case -6:
            // 'Maintenance';
            return "/static/img/status/escalator-fault.png"
          case -7:
            // 'Inspection';
            return "/static/img/status/escalator-fault.png"
        }
        return "/static/img/status/escalator-down.png"
      }

      //return "/static/img/status/disabled-evacuation.png"
      //return "/static/img/status/division.png"
      //return "/static/img/status/fire.png"
      switch (elevator.status) {
        case 9:
          // Power lost
          return "/static/img/status/supply-fault.png"
        case 8:
          // 'Evac'
          return "/static/img/status/removed.png"
        case 7:
          // 'Alarm'
          return "/static/img/status/alarm.png"
        case 6:
          // 'Fire'
          return "/static/img/status/fire.png"
        case 5:
          // 'Error';
          return "/static/img/status/maintenance.png"
        case 4:
        // 'Shutdown';
        case 3:
          // 'Offline 24h';
          return "/static/img/status/supply-fault.png"
        case 2:
          // 'Offline 2h';
          return "/static/img/status/supply-fault.png"
        case 1:
          // 'Normal'
          //return "/static/img/status/up.png"
          //return "/static/img/status/down.png"
          //return "/static/img/status/opening.png"
          //return "/static/img/status/closing.png"

          if (elevator.doorFront == 1 || elevator.doorBack == 1) {
            return "/static/img/status/closed.png"
          } else if (elevator.doorFront == 2 || elevator.doorBack == 2) {
            return "/static/img/status/opened.png"
          }

        case 0:
        // 'Unknown';
        case -1:
          // 'Ignore';
          return "/static/img/status/maintenance.png"
        case -2:
          // 'Maintenance';
          return "/static/img/status/maintenance.png"
        case -3:
          // 'Inspection';
          return "/static/img/status/maintenance.png"
        case -4:
          // 'Maintenance';
          return "/static/img/status/maintenance.png"
        case -5:
          // 'Inspection';
          return "/static/img/status/maintenance.png"
        case -6:
          // 'Maintenance';
          return "/static/img/status/maintenance.png"
        case -7:
          // 'Inspection';
          return "/static/img/status/maintenance.png"
      }

      return "/static/img/status/closed.png"
    },
    nameForStatus(status) {
      switch (status) {
        case 9:
          return 'Power lost'
        case 8:
          return 'Removed from service'
        case 7:
          return 'Alarm'
        case 6:
          return 'Fire recovery'
        case 5:
          return 'Fault';
        case 4:
          return 'Shutdown';
        case 3:
          return 'Offline 24h';
        case 2:
          return 'Offline';
        case 1:
          return 'Normal';
        case 0:
          return 'Unknown';
        case -1:
          return 'Disabled';
        case -2:
          return 'Maintenance';
        case -3:
          return 'Inspection';
        case -4:
          return 'Maintenance';
        case -5:
          return 'Inspection';
        case -6:
          return 'Maintenance';
        case -7:
          return 'Inspection';
      }
    },
    statusTextForGroup(status) {
      var output = "Normal";

      switch (status) {
        case 9:
          output = 'Power lost';
          break;
        case 8:
          output = 'Removed from service';
          break;
        case 7:
          output = 'Alarm';
          break;
        case 6:
          output = 'Fire recovery';
          break;
        case 5:
          output = 'Fault';
          break;
        case 4:
          output = 'Shutdown';
          break;
        case 3:
          break;
        case 2:
          break;
        case 1:
          break;
        case 0:
          break;
        case -1:
          output = 'Disabled';
          break;
        case -2:
          output = 'Maintenance';
          break;
        case -3:
          output = 'Inspection';
          break;
        case -4:
          output = 'Maintenance';
          break;
        case -5:
          output = 'Inspection';
          break;
        case -6:
          output = 'Maintenance';
          break;
        case -7:
          output = 'Inspection';
          break;
      }

      return output;
    },
    statusForGroup(group) {
      var output = 1;

      for (var j = 0; j < group.elevators.length; j++) {
        var elevator = group.elevators[j];

        switch (elevator.status) {
          case 8:
            output = elevator.status;
            break;
          case 7:
            output = elevator.status;
            break;
          case 6:
            output = elevator.status;
            break;
          case 5:
            output = elevator.status;
            break;
          case 4:
            if (output != 5)
              output = elevator.status;
            break;
          case 3:
            continue
          case 2:
            continue
          case 1:
            continue
          case 0:
            continue
          case -1:
            if (output != 5)
              output = elevator.status;
            break;
          case -2:
            if (output != 5)
              output = elevator.status;
            break;
          case -3:
            if (output != 5)
              output = elevator.status;
            break;
          case -4:
            if (output != 5)
              output = elevator.status;
            break;
          case -5:
            if (output != 5)
              output = elevator.status;
            break;
          case -6:
            if (output != 5)
              output = elevator.status;
            break;
          case -7:
            if (output != 5)
              output = elevator.status;
            break;
        }
      }

      return output;
    },

    statusClassForGroup(status) {
      var output = "operational-online";

      switch (status) {
        case 9:
          return 'poweroff';
        case 8:
          return 'evac';
        case 7:
          return 'alarm';
        case 6:
          return 'fire';
        case 5:
          return 'error';
        case 4:
          output = 'shutdown';
          break;
        case 3:
          break;
        case 2:
          break;
        case 1:
          break;
        case 0:
          break;
        case -1:
          output = 'repair';
          break;
        case -2:
          output = 'maintenance-offline-24h';
          break;
        case -3:
          output = 'inspection-offline-24h';
          break;
        case -4:
          output = 'maintenance-offline-2h';
          break;
        case -5:
          output = 'inspection-offline-2h';
          break;
        case -6:
          output = 'maintenance-online';
          break;
        case -7:
          output = 'inspection-online';
          break;
      }

      return output;
    },
    elevatorConfigStatusFormatter: function (status) {
      switch (status) {
        case 0:
          return 'Ready to configure';
        case 1:
          return 'Waiting for device';
        case 2:
          return 'Connecting to controller';
        case 3:
          return 'Configuration successful';
        case 4:
          return 'Configuration failed';
      }
    },
    outageDurationFormatter: function (time) {
      if (!time && time !== 0) return '';
      if (time < 60) { const s = Math.round(time); return s + (s === 1 ? ' second' : ' seconds'); }
      return moment.duration(time, "seconds").humanize();
    },
    signalFormatter: function (rssi) {
      var label = "";
      var dbm = -112.5 + (rssi * 2);

      if (rssi > 19) {
        label = "Excellent";
      } else if (rssi > 14) {
        label = "Good";
      } else if (rssi > 9) {
        label = "Fair";
      } else if (rssi < 10) {
        label = "Poor";
      }

      return label + " (" + dbm + " dBm)";
    },
    dateFormatter: function (date) {
      return moment(date).format('YYYY-MM-DD');
    },
    datetimeFormatter: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    eventTimeFormatter: function (time) {
      return this.datetimeFormatter(time);
    },
    outageTimeFormatter: function (time) {
      return this.prettyDate(time);
    },
    eventDurationFormatter: function (time) {
      return moment.duration(time, "seconds").humanize();
    },
    prettyDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm');
    },
    elevatorFormatter: function (value) {
      return this.elevatorBrandFormatter(value) + " " + this.elevatorTypeFormatter(value);

    },
    elevatorBrandFormatter: function (value) {
      var brand = "Unknown";

      if (value in this.ElevatorTypes) {
        brand = this.ElevatorTypes[value].brand;
      }

      if (brand == undefined) {
        brand = "Unknown";
      }

      return brand;
    },
    elevatorTypeFormatter: function (value) {
      var type = "Unknown";

      if (value in this.ElevatorTypes) {
        type = this.ElevatorTypes[value].type;
      }

      if (type == undefined) {
        type = "Unknown";
      }

      return type;
    },
    waterlevelFormatter(value) {
      switch (value) {
        case -2: return 'No sensor';
        case -1: return 'Error';
        case 0:  return 'None';
        case 1:  return 'Low';
        default: return 'High';
      }
    },
    eventDescriptionForType: function (value, msg) {
      switch (value) {
        case 'alarm':
          return "Alarm button pressed (> 3s)";
        case 'restart':
          return "Restarted connection";
        case 'connect':
          return "Connected to controller";
        case 'outage':
          return "Lift out of service";
        case 'outage-end':
          return "Lift in service";
        case 'outage-resolved':
          return "Lift in service";
        case 'service':
          return "Maintenance";
        case 'service-end':
          return "Maintenance";
        case 'shutdown':
          return "Controller shutdown";
        case 'power-on':
          return "Power restored";
        case 'power-off':
          return "Power lost";
        case 'waterlevel':
          return this.waterlevelFormatter(parseInt(msg));
        default:
          return msg;
      }
    },
    eventTypeFormatter: function (value, item) {
      switch (value) {
        case 'reset':
          return "Reset";
        case 'alarm':
          return "Alarm";
        case 'restart':
          return "Restart"
        case 'connect':
          return "Connect"
        case 'error':
          return "Fault"
        case 'outage':
          return "Breakdown"
        case 'outage-end':
          return "Breakdown ended"
        case 'outage-resolved':
          return "Breakdown ended"
        case 'service':
          return "Maintenance"
        case 'service-end':
          return "Maintenance ended";
        case 'repair-end':
          return "Monitoring enabled";
        case 'mode':
          return "Mode";
        case 'power-on':
          return "Power restored";
        case 'power-off':
          return "Power lost";
        case 'waterlevel':
          return "Water level";
        default:
          return value;
      }
    },
  }
}




// WEBPACK FOOTER //
// ./src/formatter.mixin.js